import styled from 'styled-components';

export const StyledBroadsiderTraits = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px 0 20px;
  height: calc(${({ theme }) => theme.traitHeight} * ${({ $rowsize }) => $rowsize} + 12px * ${({ $rowsize }) => $rowsize});
  min-height: calc(${({ theme }) => theme.traitHeight} * ${({ $rowsize }) => $rowsize} + 12px * ${({ $rowsize }) => $rowsize});
  margin-bottom: 12px;
  overflow-y: auto;

  .traits-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .trait-container {
    width: 49%;
    max-width: 49%;
    min-width: 49%;
  }

  .trait-container-single {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }
`;
